/**
 * Toast Notifications Store
 * Manages toast notifications with auto-dismiss
 */

import { create } from 'zustand';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

interface ToastState {
  toasts: Toast[];
  addToast: (typeOrToast: ToastType | { type: ToastType; message: string }, message?: string) => void;
  removeToast: (id: string) => void;
  clearAll: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (typeOrToast, message?) => {
    // Support both: addToast('success', 'msg') and addToast({ type: 'success', message: 'msg' })
    const toastType = typeof typeOrToast === 'object' ? typeOrToast.type : typeOrToast;
    const toastMessage = typeof typeOrToast === 'object' ? typeOrToast.message : message!;
    
    const id = `toast-${Date.now()}-${Math.random()}`;
    set((state) => ({
      toasts: [...state.toasts, { id, type: toastType, message: toastMessage }],
    }));
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  clearAll: () => {
    set({ toasts: [] });
  },
}));






